import * as React from "react";
import type { SVGProps } from "react";
const SvgCloseBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.75 10.75 12.5 12.5M10.75 23.25l12.5-12.5"
    />
  </svg>
);
export default SvgCloseBig;
